export default "__VITE_ASSET__DNjcqp7K__"